module.exports = __webpack_public_path__ + "static/img/b3_body.04d40fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/core/b3_body.png
// module id = lAqT
// module chunks = 1